import { useLocation, useParams } from 'react-router-dom';

/**
 * The profile tab's own path (`…/customers/c-1/knowledge`), whatever subtab the
 * `:tabId/*` splat names — the base for a link to a sibling subtab.
 *
 * Built from the current path minus the splat: with `v7_relativeSplatPath` a
 * relative link would resolve against the splat route's FULL path and land on
 * `…/drive/sandbox`. One place for that arithmetic (CT-5717 review).
 */
export function useTabPath() {
  const params = useParams();
  const { pathname } = useLocation();
  const splat = params['*'] ?? '';
  return pathname.slice(0, pathname.length - splat.length).replace(/\/$/, '');
}

export default useTabPath;
